import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StaticFileService } from './static-file.service';
import { RestApiService } from './rest-api.service';
import { CookieService } from './cookie.service';
import { GoogleAnalyticsService } from './google-analytics.service';
import { BannerPaintingComponent } from './banner-painting/banner-painting.component';
import { HeaderComponent } from './header/header.component';
import { NavComponent } from './nav/nav.component';
import { AboutPageComponent } from './about-page/about-page.component';
import { CartPageComponent } from './cart-page/cart-page.component';
import { ShopPageComponent } from './shop-page/shop-page.component';
import { BaseInventoryComponent } from './shop-page/base-inventory/base-inventory.component';
import { OriginalInventoryComponent } from './shop-page/original-inventory/original-inventory.component';
import { PrintInventoryComponent } from './shop-page/print-inventory/print-inventory.component';
import { PastInventoryComponent } from './shop-page/past-inventory/past-inventory.component';
import { MerchCollectionComponent } from './shop-page/merch-collection/merch-collection.component';
import { ItemModalComponent } from './shop-page/item-modal/item-modal.component';
import { CartInventoryComponent } from './cart-page/cart-inventory/cart-inventory.component';
import { ShippingFormComponent } from './cart-page/shipping-form/shipping-form.component';
import { CartPaymentComponent } from './cart-page/cart-payment/cart-payment.component';
import { ConfirmationPageComponent } from './cart-page/confirmation-page/confirmation-page.component';
import { FullViewerComponent } from './shop-page/full-viewer/full-viewer.component';


export function init(staticFileService: StaticFileService): () => void {
  return () => {
    staticFileService.init();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    BannerPaintingComponent,
    HeaderComponent,
    NavComponent,
    AboutPageComponent,
    CartPageComponent,
    ShopPageComponent,
    BaseInventoryComponent,
    OriginalInventoryComponent,
    PrintInventoryComponent,
    PastInventoryComponent,
    MerchCollectionComponent,
    ItemModalComponent,
    CartInventoryComponent,
    ShippingFormComponent,
    CartPaymentComponent,
    ConfirmationPageComponent,
    FullViewerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'csrftoken',
      headerName: 'X-CSRFToken'
    }),
    FormsModule
  ],
  providers: [
    StaticFileService,
    RestApiService,
    CookieService,
    GoogleAnalyticsService,
    {provide: APP_INITIALIZER, useFactory: init, deps: [StaticFileService], multi: true}
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
